import { LOCALES, THEMES } from '../../../constants';
import { IReduxAction } from '../../../services/interfaces/common-interface';
import { SET_THEME, SET_LANGUAGE } from './app-constants';

export type ThemeInitialStateType = {
  theme: string;
  locale: string;
};

const initialState = {
  theme: THEMES.DEFAULT,
  locale: LOCALES.PORTUGUESE
};

export default function reducer(state = initialState, action: IReduxAction): ThemeInitialStateType {
  switch (action.type) {
    case SET_THEME: {
      return {
        ...state,
        theme: action.payload
      };
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        locale: action.payload
      };
    }

    default:
      return state;
  }
}
